<template>
  <div v-if="show" class="open-with-option-dialog-container">
    <wxc-overlay :left='left' :show="true" :hasAnimation="false"></wxc-overlay>
    <div class="dialog-box" :style="{top:top+'px', left: left + 'px', right: right + 'px'}">
      <div class="dialog-content-without-cross">

        <weex-text class="font-size-base font-weight-bold text-color-black margin-bottom-5"
                   v-html="openWithMessage"></weex-text>

        <div v-for="(option, index) in openWithOptions" :key="option + index">
          <weex-text
              class="text-color-black margin-top-5 margin-left-5">
              <span
                  v-html="option"
                  class="padding-10 font-size-sm-base item-cursor"
                  @click="onOptionSelected(option)"
              ></span>
          </weex-text>
        </div>

        <weex-text class="text-align-center margin-top-10">
          <span
              class="padding-10 font-size-sm-base item-cursor text-color-red"
              @click="onDismissClicked"
          >Dismiss</span>
        </weex-text>

      </div>
    </div>
  </div>
</template>

<script>
import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";

export default {
  components: {WxcOverlay},
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    openWithMessage: {
      type: String,
      default: "Open with"
    },

    openWithOptions: {
      type: Array,
      default: () => ["Camera", "Gallery"]
    },

    top: {
      type: Number,
      default: 0
    },

    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    }
  },

  methods: {
    onDismissClicked() {
      this.$emit("onDismiss")
    },

    onOptionSelected(option) {
      this.$emit("onOptionSelected", option);
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.open-with-option-dialog-container {
  position: fixed;
  z-index: 9999;
}
</style>
